<template>
  <div class="selected-filters">
    <span class="ml-1">Selected Filters: </span>
    <span class="selected-filters__item" v-for="filter in filters">
      <span class="font-weight-bolder">{{ filter.label }}: </span>
      <span>
        <template v-if="filter.type === 'search' || filter.type === 'numbers_range'"> {{ filter.value }}</template>
        <template v-if="filter.type === 'date-range'"> {{ filter.value.from }} - {{ filter.value.to }}</template>

        <template v-if="filter.type === 'select'">
         <template v-if="filter.multiple">
            <template v-for="(i, index) in filter.value">
              {{ i.text }}{{ (index + 1) === filter.value.length ? '' : ', ' }}
            </template>
          </template>
          <template v-else>{{ filter.value.text }}</template>
        </template>

        <template v-if="filter.type === 'select-autocomplete'">
          <template v-if="filter.multiple">
            <template v-for="(i, index) in filter.value">
              {{ i.text }}{{ (index + 1) === filter.value.length ? '' : ', ' }}
            </template>
          </template>
          <template v-else>{{ filter.value.text }}</template>
        </template>

        <template v-if="filter.type === 'tags'">
          <template v-for="(i, index) in filter.value">
            {{ i }}{{ (index + 1) === filter.value.length ? '' : ', ' }}
          </template>
        </template>
      </span>

      <feather-icon icon="XIcon" class="text-primary cursor-pointer" size="15" @click="remove(filter)"/>
    </span>
  </div>
</template>
<script>

export default {
  props: {
    filters: {
      type: Array,
      default: []
    }
  },
  methods: {
    remove(filter) {
      this.$set(filter, 'value', null);
      this.$delete(filter, 'errors');

      return this.$emit('refetch-data')
    }
  }
}
</script>